import Big from 'big.js';

import { CardProduct } from 'app/model/product/CardProduct';
import { InsuranceProduct } from 'app/model/product/InsuranceProduct';

export class KkgCardProduct extends CardProduct {
    /**
     * Ставка в грейс-периоде
     */
    graceRate: Big;

    /**
     * Срок предоставления (месяцы)
     */
    graceTerm: number;

    /**
     * Сумма комиссии за обслуживание карты
     */
    commissionAmount: Big;

    /**
     * Ставка на остаток собственных средств на карте
     */
    restAmountRate: Big;

    constructor(
        id: string,
        code: string,
        name: string,
        minAmount: Big,
        maxAmount: Big,
        soleTradersMaxAmount: Big,
        selfEmployedMaxAmount: Big,
        currency: string,
        rate: Big,
        grantTerm: number,
        paymentTerm: number,
        insurance: Array<InsuranceProduct>,
        insuranceRequired: boolean,
        insuranceEnabled: boolean,
        graceRate: Big,
        graceTerm: number,
        commissionAmount: Big,
        restAmountRate: Big,
        minInterestRate: Big,
    ) {
        super(
            id,
            code,
            name,
            minAmount,
            maxAmount,
            soleTradersMaxAmount,
            selfEmployedMaxAmount,
            currency,
            rate,
            grantTerm,
            paymentTerm,
            insurance,
            insuranceRequired,
            insuranceEnabled,
            minInterestRate,
        );
        this.graceRate = graceRate;
        this.graceTerm = graceTerm;
        this.commissionAmount = commissionAmount;
        this.restAmountRate = restAmountRate;
    }

    static deserialize(data: any) {
        return new KkgCardProduct(
            data.id,
            data.code,
            data.name,
            new Big(data.minAmount),
            new Big(data.maxAmount),
            new Big(data.soleTradersMaxAmount),
            new Big(data.selfEmployedMaxAmount),
            data.currency,
            new Big(data.rate),
            data.grantTerm,
            data.paymentTerm,
            data.insurance.map(InsuranceProduct.deserialize),
            data.insuranceRequired,
            data.insuranceEnabled,
            new Big(data.graceRate),
            data.graceTerm,
            new Big(data.commissionAmount),
            new Big(data.restAmountRate),
            new Big(data.minInterestRate),
        );
    }
}
